export type WorldCountry = {
  iso2: string;
  slug: string;
  name: string;
  lat: number;
  lng: number;
};

/** Country centroids for low-zoom flag markers (Natural Earth / community centroids). */
export const WORLD_COUNTRIES: WorldCountry[] = [
  {
    "iso2": "af",
    "slug": "afghanistan",
    "name": "Afghanistan",
    "lat": 34.134,
    "lng": 66.5922
  },
  {
    "iso2": "al",
    "slug": "albania",
    "name": "Albania",
    "lat": 41.1417,
    "lng": 20.0611
  },
  {
    "iso2": "dz",
    "slug": "algeria",
    "name": "Algeria",
    "lat": 28.351,
    "lng": 2.6558
  },
  {
    "iso2": "as",
    "slug": "american-samoa",
    "name": "American Samoa",
    "lat": -14.3057,
    "lng": -170.7007
  },
  {
    "iso2": "ad",
    "slug": "andorra",
    "name": "Andorra",
    "lat": 42.5486,
    "lng": 1.5802
  },
  {
    "iso2": "ao",
    "slug": "angola",
    "name": "Angola",
    "lat": -12.1674,
    "lng": 17.6518
  },
  {
    "iso2": "ai",
    "slug": "anguilla",
    "name": "Anguilla",
    "lat": 18.2229,
    "lng": -63.0601
  },
  {
    "iso2": "aq",
    "slug": "antarctica",
    "name": "Antarctica",
    "lat": -77.1699,
    "lng": -177.5645
  },
  {
    "iso2": "ag",
    "slug": "antigua-and-barbuda",
    "name": "Antigua and Barbuda",
    "lat": 17.0715,
    "lng": -61.7853
  },
  {
    "iso2": "ar",
    "slug": "argentina",
    "name": "Argentina",
    "lat": -35.6973,
    "lng": -64.5324
  },
  {
    "iso2": "am",
    "slug": "armenia",
    "name": "Armenia",
    "lat": 40.1784,
    "lng": 45.0549
  },
  {
    "iso2": "aw",
    "slug": "aruba",
    "name": "Aruba",
    "lat": 12.5156,
    "lng": -69.9756
  },
  {
    "iso2": "au",
    "slug": "australia",
    "name": "Australia",
    "lat": -25.6973,
    "lng": 134.0228
  },
  {
    "iso2": "at",
    "slug": "austria",
    "name": "Austria",
    "lat": 47.6319,
    "lng": 13.7978
  },
  {
    "iso2": "az",
    "slug": "azerbaijan",
    "name": "Azerbaijan",
    "lat": 40.3921,
    "lng": 48.6346
  },
  {
    "iso2": "bs",
    "slug": "bahamas",
    "name": "Bahamas",
    "lat": 24.7216,
    "lng": -78.0728
  },
  {
    "iso2": "bh",
    "slug": "bahrain",
    "name": "Bahrain",
    "lat": 26.048,
    "lng": 50.5407
  },
  {
    "iso2": "bd",
    "slug": "bangladesh",
    "name": "Bangladesh",
    "lat": 23.6737,
    "lng": 90.4321
  },
  {
    "iso2": "bb",
    "slug": "barbados",
    "name": "Barbados",
    "lat": 13.1832,
    "lng": -59.5574
  },
  {
    "iso2": "by",
    "slug": "belarus",
    "name": "Belarus",
    "lat": 53.4679,
    "lng": 27.9643
  },
  {
    "iso2": "be",
    "slug": "belgium",
    "name": "Belgium",
    "lat": 50.6182,
    "lng": 4.675
  },
  {
    "iso2": "bz",
    "slug": "belize",
    "name": "Belize",
    "lat": 17.2425,
    "lng": -88.6827
  },
  {
    "iso2": "bj",
    "slug": "benin",
    "name": "Benin",
    "lat": 9.503,
    "lng": 2.3057
  },
  {
    "iso2": "bm",
    "slug": "bermuda",
    "name": "Bermuda",
    "lat": 32.3151,
    "lng": -64.7459
  },
  {
    "iso2": "bt",
    "slug": "bhutan",
    "name": "Bhutan",
    "lat": 27.4216,
    "lng": 90.4672
  },
  {
    "iso2": "bo",
    "slug": "bolivia",
    "name": "Bolivia",
    "lat": -16.7312,
    "lng": -64.4521
  },
  {
    "iso2": "bq",
    "slug": "bonaire",
    "name": "Bonaire",
    "lat": 12.1808,
    "lng": -68.2935
  },
  {
    "iso2": "ba",
    "slug": "bosnia-and-herzegovina",
    "name": "Bosnia and Herzegovina",
    "lat": 44.1442,
    "lng": 17.8347
  },
  {
    "iso2": "bw",
    "slug": "botswana",
    "name": "Botswana",
    "lat": -22.2366,
    "lng": 23.8578
  },
  {
    "iso2": "bv",
    "slug": "bouvet-island",
    "name": "Bouvet Island",
    "lat": -54.4232,
    "lng": 3.412
  },
  {
    "iso2": "br",
    "slug": "brazil",
    "name": "Brazil",
    "lat": -11.5246,
    "lng": -54.3552
  },
  {
    "iso2": "io",
    "slug": "british-indian-ocean-territory",
    "name": "British Indian Ocean Territory",
    "lat": -7.3235,
    "lng": 72.435
  },
  {
    "iso2": "vg",
    "slug": "british-virgin-islands",
    "name": "British Virgin Islands",
    "lat": 18.422,
    "lng": -64.6241
  },
  {
    "iso2": "bn",
    "slug": "brunei-darussalam",
    "name": "Brunei Darussalam",
    "lat": 4.5432,
    "lng": 114.6431
  },
  {
    "iso2": "bg",
    "slug": "bulgaria",
    "name": "Bulgaria",
    "lat": 42.8204,
    "lng": 25.2517
  },
  {
    "iso2": "bf",
    "slug": "burkina-faso",
    "name": "Burkina Faso",
    "lat": 12.1087,
    "lng": -1.6933
  },
  {
    "iso2": "bi",
    "slug": "burundi",
    "name": "Burundi",
    "lat": -3.2613,
    "lng": 29.8852
  },
  {
    "iso2": "cv",
    "slug": "cape-verde",
    "name": "Cabo Verde",
    "lat": 15.0764,
    "lng": -23.634
  },
  {
    "iso2": "kh",
    "slug": "cambodia",
    "name": "Cambodia",
    "lat": 12.6992,
    "lng": 105.0397
  },
  {
    "iso2": "cm",
    "slug": "cameroon",
    "name": "Cameroon",
    "lat": 6.2942,
    "lng": 12.9485
  },
  {
    "iso2": "ca",
    "slug": "canada",
    "name": "Canada",
    "lat": 57.5505,
    "lng": -98.4168
  },
  {
    "iso2": "ky",
    "slug": "cayman-islands",
    "name": "Cayman Islands",
    "lat": 19.3112,
    "lng": -81.252
  },
  {
    "iso2": "cf",
    "slug": "central-african-republic",
    "name": "Central African Republic",
    "lat": 6.3314,
    "lng": 20.5207
  },
  {
    "iso2": "td",
    "slug": "chad",
    "name": "Chad",
    "lat": 15.2835,
    "lng": 18.4271
  },
  {
    "iso2": "cl",
    "slug": "chile",
    "name": "Chile",
    "lat": -37.8294,
    "lng": -70.7686
  },
  {
    "iso2": "cn",
    "slug": "china",
    "name": "China",
    "lat": 38.0733,
    "lng": 104.6911
  },
  {
    "iso2": "cx",
    "slug": "christmas-island",
    "name": "Christmas Island",
    "lat": -10.4464,
    "lng": 105.7021
  },
  {
    "iso2": "cc",
    "slug": "cocos-islands",
    "name": "Cocos Islands",
    "lat": -12.1712,
    "lng": 96.8369
  },
  {
    "iso2": "co",
    "slug": "colombia",
    "name": "Colombia",
    "lat": 4.1878,
    "lng": -72.6445
  },
  {
    "iso2": "km",
    "slug": "comoros",
    "name": "Comoros",
    "lat": -11.6589,
    "lng": 43.3483
  },
  {
    "iso2": "cg",
    "slug": "republic-of-the-congo",
    "name": "Congo",
    "lat": -0.7294,
    "lng": 14.8797
  },
  {
    "iso2": "cd",
    "slug": "democratic-republic-of-the-congo",
    "name": "Congo DRC",
    "lat": -3.3386,
    "lng": 23.4198
  },
  {
    "iso2": "ck",
    "slug": "cook-islands",
    "name": "Cook Islands",
    "lat": -21.2226,
    "lng": -159.7877
  },
  {
    "iso2": "cr",
    "slug": "costa-rica",
    "name": "Costa Rica",
    "lat": 9.8635,
    "lng": -84.1467
  },
  {
    "iso2": "hr",
    "slug": "croatia",
    "name": "Croatia",
    "lat": 44.9119,
    "lng": 16.6258
  },
  {
    "iso2": "cu",
    "slug": "cuba",
    "name": "Cuba",
    "lat": 21.4762,
    "lng": -79.6982
  },
  {
    "iso2": "cw",
    "slug": "curacao",
    "name": "Curacao",
    "lat": 12.2,
    "lng": -68.9694
  },
  {
    "iso2": "cy",
    "slug": "cyprus",
    "name": "Cyprus",
    "lat": 35.117,
    "lng": 33.3753
  },
  {
    "iso2": "cz",
    "slug": "czech-republic",
    "name": "Czech Republic",
    "lat": 49.7492,
    "lng": 15.3833
  },
  {
    "iso2": "ci",
    "slug": "ivory-coast",
    "name": "C\u00f4te d'Ivoire",
    "lat": 7.5368,
    "lng": -5.5717
  },
  {
    "iso2": "dk",
    "slug": "denmark",
    "name": "Denmark",
    "lat": 56.0012,
    "lng": 9.3787
  },
  {
    "iso2": "dj",
    "slug": "djibouti",
    "name": "Djibouti",
    "lat": 11.7502,
    "lng": 42.6135
  },
  {
    "iso2": "dm",
    "slug": "dominica",
    "name": "Dominica",
    "lat": 15.4293,
    "lng": -61.3605
  },
  {
    "iso2": "do",
    "slug": "dominican-republic",
    "name": "Dominican Republic",
    "lat": 18.7795,
    "lng": -70.435
  },
  {
    "iso2": "ec",
    "slug": "ecuador",
    "name": "Ecuador",
    "lat": -1.5643,
    "lng": -78.463
  },
  {
    "iso2": "eg",
    "slug": "egypt",
    "name": "Egypt",
    "lat": 26.6052,
    "lng": 30.2401
  },
  {
    "iso2": "sv",
    "slug": "el-salvador",
    "name": "El Salvador",
    "lat": 13.758,
    "lng": -88.8591
  },
  {
    "iso2": "gb-eng",
    "slug": "england",
    "name": "England",
    "lat": 52.3555,
    "lng": -1.1743
  },
  {
    "iso2": "gq",
    "slug": "equatorial-guinea",
    "name": "Equatorial Guinea",
    "lat": 1.5955,
    "lng": 10.4255
  },
  {
    "iso2": "er",
    "slug": "eritrea",
    "name": "Eritrea",
    "lat": 15.0055,
    "lng": 39.2672
  },
  {
    "iso2": "ee",
    "slug": "estonia",
    "name": "Estonia",
    "lat": 58.6481,
    "lng": 25.9169
  },
  {
    "iso2": "sz",
    "slug": "eswatini",
    "name": "Eswatini",
    "lat": -26.5625,
    "lng": 31.5107
  },
  {
    "iso2": "et",
    "slug": "ethiopia",
    "name": "Ethiopia",
    "lat": 8.7294,
    "lng": 39.9149
  },
  {
    "iso2": "fk",
    "slug": "falkland-islands",
    "name": "Falkland Islands",
    "lat": -51.759,
    "lng": -58.7466
  },
  {
    "iso2": "fo",
    "slug": "faroe-islands",
    "name": "Faroe Islands",
    "lat": 62.1309,
    "lng": -6.9811
  },
  {
    "iso2": "fj",
    "slug": "fiji",
    "name": "Fiji",
    "lat": -17.8225,
    "lng": 177.9814
  },
  {
    "iso2": "fi",
    "slug": "finland",
    "name": "Finland",
    "lat": 65.0158,
    "lng": 25.6574
  },
  {
    "iso2": "fr",
    "slug": "france",
    "name": "France",
    "lat": 46.6424,
    "lng": 2.194
  },
  {
    "iso2": "gf",
    "slug": "french-guiana",
    "name": "French Guiana",
    "lat": 3.8574,
    "lng": -53.3223
  },
  {
    "iso2": "pf",
    "slug": "french-polynesia",
    "name": "French Polynesia",
    "lat": -17.6747,
    "lng": -149.4004
  },
  {
    "iso2": "ga",
    "slug": "gabon",
    "name": "Gabon",
    "lat": -0.6284,
    "lng": 11.8394
  },
  {
    "iso2": "gm",
    "slug": "gambia",
    "name": "Gambia",
    "lat": 13.4286,
    "lng": -15.3834
  },
  {
    "iso2": "ge",
    "slug": "georgia",
    "name": "Georgia",
    "lat": 42.1799,
    "lng": 43.3789
  },
  {
    "iso2": "de",
    "slug": "germany",
    "name": "Germany",
    "lat": 51.083,
    "lng": 10.4262
  },
  {
    "iso2": "gh",
    "slug": "ghana",
    "name": "Ghana",
    "lat": 7.9453,
    "lng": -1.2192
  },
  {
    "iso2": "gi",
    "slug": "gibraltar",
    "name": "Gibraltar",
    "lat": 36.1402,
    "lng": -5.3455
  },
  {
    "iso2": "gr",
    "slug": "greece",
    "name": "Greece",
    "lat": 39.4201,
    "lng": 23.1104
  },
  {
    "iso2": "gl",
    "slug": "greenland",
    "name": "Greenland",
    "lat": 74.1685,
    "lng": -42.0757
  },
  {
    "iso2": "gd",
    "slug": "grenada",
    "name": "Grenada",
    "lat": 12.1129,
    "lng": -61.6794
  },
  {
    "iso2": "gp",
    "slug": "guadeloupe",
    "name": "Guadeloupe",
    "lat": 16.2442,
    "lng": -61.5438
  },
  {
    "iso2": "gu",
    "slug": "guam",
    "name": "Guam",
    "lat": 13.4454,
    "lng": 144.7802
  },
  {
    "iso2": "gt",
    "slug": "guatemala",
    "name": "Guatemala",
    "lat": 15.8209,
    "lng": -90.3122
  },
  {
    "iso2": "gg",
    "slug": "guernsey",
    "name": "Guernsey",
    "lat": 49.4587,
    "lng": -2.5764
  },
  {
    "iso2": "gn",
    "slug": "guinea",
    "name": "Guinea",
    "lat": 10.256,
    "lng": -10.9869
  },
  {
    "iso2": "gw",
    "slug": "guinea-bissau",
    "name": "Guinea-Bissau",
    "lat": 11.9801,
    "lng": -14.9802
  },
  {
    "iso2": "gy",
    "slug": "guyana",
    "name": "Guyana",
    "lat": 4.6821,
    "lng": -58.9135
  },
  {
    "iso2": "ht",
    "slug": "haiti",
    "name": "Haiti",
    "lat": 18.8835,
    "lng": -72.8929
  },
  {
    "iso2": "hm",
    "slug": "heard-island-and-mcdonald-islands",
    "name": "Heard Island and McDonald Islands",
    "lat": -53.0842,
    "lng": 73.493
  },
  {
    "iso2": "hn",
    "slug": "honduras",
    "name": "Honduras",
    "lat": 14.7404,
    "lng": -86.4925
  },
  {
    "iso2": "hu",
    "slug": "hungary",
    "name": "Hungary",
    "lat": 47.2253,
    "lng": 19.3962
  },
  {
    "iso2": "is",
    "slug": "iceland",
    "name": "Iceland",
    "lat": 65.1236,
    "lng": -19.0568
  },
  {
    "iso2": "in",
    "slug": "india",
    "name": "India",
    "lat": 23.5863,
    "lng": 81.173
  },
  {
    "iso2": "id",
    "slug": "indonesia",
    "name": "Indonesia",
    "lat": 0.1559,
    "lng": 113.9654
  },
  {
    "iso2": "ir",
    "slug": "iran",
    "name": "Iran",
    "lat": 32.906,
    "lng": 54.2371
  },
  {
    "iso2": "iq",
    "slug": "iraq",
    "name": "Iraq",
    "lat": 33.1051,
    "lng": 43.8325
  },
  {
    "iso2": "ie",
    "slug": "ireland",
    "name": "Ireland",
    "lat": 53.3049,
    "lng": -8.2411
  },
  {
    "iso2": "im",
    "slug": "isle-of-man",
    "name": "Isle of Man",
    "lat": 54.2286,
    "lng": -4.533
  },
  {
    "iso2": "il",
    "slug": "israel",
    "name": "Israel",
    "lat": 31.5135,
    "lng": 35.0279
  },
  {
    "iso2": "it",
    "slug": "italy",
    "name": "Italy",
    "lat": 42.982,
    "lng": 12.7637
  },
  {
    "iso2": "jm",
    "slug": "jamaica",
    "name": "Jamaica",
    "lat": 18.1221,
    "lng": -77.3036
  },
  {
    "iso2": "jp",
    "slug": "japan",
    "name": "Japan",
    "lat": 36.7674,
    "lng": 137.4693
  },
  {
    "iso2": "je",
    "slug": "jersey",
    "name": "Jersey",
    "lat": 49.2154,
    "lng": -2.1292
  },
  {
    "iso2": "jo",
    "slug": "jordan",
    "name": "Jordan",
    "lat": 31.3871,
    "lng": 36.9573
  },
  {
    "iso2": "tf",
    "slug": "juan-de-nova-island",
    "name": "Juan De Nova Island",
    "lat": -17.0645,
    "lng": 42.7437
  },
  {
    "iso2": "kz",
    "slug": "kazakhstan",
    "name": "Kazakhstan",
    "lat": 47.6415,
    "lng": 66.3759
  },
  {
    "iso2": "ke",
    "slug": "kenya",
    "name": "Kenya",
    "lat": 0.6899,
    "lng": 37.9531
  },
  {
    "iso2": "ki",
    "slug": "kiribati",
    "name": "Kiribati",
    "lat": 1.8677,
    "lng": -157.3902
  },
  {
    "iso2": "kw",
    "slug": "kuwait",
    "name": "Kuwait",
    "lat": 29.2814,
    "lng": 47.5631
  },
  {
    "iso2": "kg",
    "slug": "kyrgyzstan",
    "name": "Kyrgyzstan",
    "lat": 41.357,
    "lng": 74.1753
  },
  {
    "iso2": "la",
    "slug": "laos",
    "name": "Laos",
    "lat": 18.1173,
    "lng": 103.7638
  },
  {
    "iso2": "lv",
    "slug": "latvia",
    "name": "Latvia",
    "lat": 56.8139,
    "lng": 24.6937
  },
  {
    "iso2": "lb",
    "slug": "lebanon",
    "name": "Lebanon",
    "lat": 33.9116,
    "lng": 35.8965
  },
  {
    "iso2": "ls",
    "slug": "lesotho",
    "name": "Lesotho",
    "lat": -29.6017,
    "lng": 28.2448
  },
  {
    "iso2": "lr",
    "slug": "liberia",
    "name": "Liberia",
    "lat": 6.5201,
    "lng": -9.259
  },
  {
    "iso2": "ly",
    "slug": "libya",
    "name": "Libya",
    "lat": 27.2029,
    "lng": 17.9113
  },
  {
    "iso2": "li",
    "slug": "liechtenstein",
    "name": "Liechtenstein",
    "lat": 47.1463,
    "lng": 9.5477
  },
  {
    "iso2": "lt",
    "slug": "lithuania",
    "name": "Lithuania",
    "lat": 55.2944,
    "lng": 23.946
  },
  {
    "iso2": "lu",
    "slug": "luxembourg",
    "name": "Luxembourg",
    "lat": 49.7752,
    "lng": 6.1032
  },
  {
    "iso2": "mg",
    "slug": "madagascar",
    "name": "Madagascar",
    "lat": -19.0416,
    "lng": 46.6849
  },
  {
    "iso2": "mw",
    "slug": "malawi",
    "name": "Malawi",
    "lat": -13.129,
    "lng": 34.2344
  },
  {
    "iso2": "my",
    "slug": "malaysia",
    "name": "Malaysia",
    "lat": 3.6717,
    "lng": 114.6333
  },
  {
    "iso2": "mv",
    "slug": "maldives",
    "name": "Maldives",
    "lat": -0.6066,
    "lng": 73.1008
  },
  {
    "iso2": "ml",
    "slug": "mali",
    "name": "Mali",
    "lat": 17.1681,
    "lng": -4.3464
  },
  {
    "iso2": "mt",
    "slug": "malta",
    "name": "Malta",
    "lat": 35.8905,
    "lng": 14.4419
  },
  {
    "iso2": "mh",
    "slug": "marshall-islands",
    "name": "Marshall Islands",
    "lat": 7.3079,
    "lng": 168.7202
  },
  {
    "iso2": "mq",
    "slug": "martinique",
    "name": "Martinique",
    "lat": 14.6427,
    "lng": -61.0143
  },
  {
    "iso2": "mr",
    "slug": "mauritania",
    "name": "Mauritania",
    "lat": 20.4667,
    "lng": -10.4951
  },
  {
    "iso2": "mu",
    "slug": "mauritius",
    "name": "Mauritius",
    "lat": -20.2814,
    "lng": 57.5642
  },
  {
    "iso2": "yt",
    "slug": "mayotte",
    "name": "Mayotte",
    "lat": -12.8245,
    "lng": 45.1281
  },
  {
    "iso2": "mx",
    "slug": "mexico",
    "name": "Mexico",
    "lat": 23.8744,
    "lng": -101.554
  },
  {
    "iso2": "fm",
    "slug": "micronesia",
    "name": "Micronesia",
    "lat": 6.8789,
    "lng": 158.2292
  },
  {
    "iso2": "md",
    "slug": "moldova",
    "name": "Moldova",
    "lat": 47.0726,
    "lng": 28.3911
  },
  {
    "iso2": "mc",
    "slug": "monaco",
    "name": "Monaco",
    "lat": 43.748,
    "lng": 7.4128
  },
  {
    "iso2": "mn",
    "slug": "mongolia",
    "name": "Mongolia",
    "lat": 47.0864,
    "lng": 103.3987
  },
  {
    "iso2": "me",
    "slug": "montenegro",
    "name": "Montenegro",
    "lat": 42.7369,
    "lng": 19.2951
  },
  {
    "iso2": "ms",
    "slug": "montserrat",
    "name": "Montserrat",
    "lat": 16.7354,
    "lng": -62.1869
  },
  {
    "iso2": "ma",
    "slug": "morocco",
    "name": "Morocco",
    "lat": 28.6876,
    "lng": -8.8172
  },
  {
    "iso2": "mz",
    "slug": "mozambique",
    "name": "Mozambique",
    "lat": -17.5252,
    "lng": 35.2086
  },
  {
    "iso2": "mm",
    "slug": "myanmar",
    "name": "Myanmar",
    "lat": 19.9012,
    "lng": 97.0889
  },
  {
    "iso2": "na",
    "slug": "namibia",
    "name": "Namibia",
    "lat": -21.9086,
    "lng": 18.1645
  },
  {
    "iso2": "nr",
    "slug": "nauru",
    "name": "Nauru",
    "lat": -0.5221,
    "lng": 166.9294
  },
  {
    "iso2": "np",
    "slug": "nepal",
    "name": "Nepal",
    "lat": 28.3009,
    "lng": 84.1339
  },
  {
    "iso2": "nl",
    "slug": "netherlands",
    "name": "Netherlands",
    "lat": 52.1341,
    "lng": 5.5541
  },
  {
    "iso2": "nc",
    "slug": "new-caledonia",
    "name": "New Caledonia",
    "lat": -21.33,
    "lng": 165.5077
  },
  {
    "iso2": "nz",
    "slug": "new-zealand",
    "name": "New Zealand",
    "lat": -43.8277,
    "lng": 170.6904
  },
  {
    "iso2": "ni",
    "slug": "nicaragua",
    "name": "Nicaragua",
    "lat": 12.8936,
    "lng": -85.0161
  },
  {
    "iso2": "ne",
    "slug": "niger",
    "name": "Niger",
    "lat": 17.0811,
    "lng": 8.8686
  },
  {
    "iso2": "ng",
    "slug": "nigeria",
    "name": "Nigeria",
    "lat": 9.6103,
    "lng": 8.1477
  },
  {
    "iso2": "nu",
    "slug": "niue",
    "name": "Niue",
    "lat": -19.0523,
    "lng": -169.8688
  },
  {
    "iso2": "nf",
    "slug": "norfolk-island",
    "name": "Norfolk Island",
    "lat": -29.0377,
    "lng": 167.9526
  },
  {
    "iso2": "kp",
    "slug": "north-korea",
    "name": "North Korea",
    "lat": 40.192,
    "lng": 127.338
  },
  {
    "iso2": "mk",
    "slug": "north-macedonia",
    "name": "North Macedonia",
    "lat": 41.594,
    "lng": 21.71
  },
  {
    "iso2": "mp",
    "slug": "northern-mariana-islands",
    "name": "Northern Mariana Islands",
    "lat": 15.1781,
    "lng": 145.7412
  },
  {
    "iso2": "no",
    "slug": "norway",
    "name": "Norway",
    "lat": 64.9778,
    "lng": 16.6703
  },
  {
    "iso2": "om",
    "slug": "oman",
    "name": "Oman",
    "lat": 20.7243,
    "lng": 55.8411
  },
  {
    "iso2": "pk",
    "slug": "pakistan",
    "name": "Pakistan",
    "lat": 30.1162,
    "lng": 69.0884
  },
  {
    "iso2": "pw",
    "slug": "palau",
    "name": "Palau",
    "lat": 7.5348,
    "lng": 134.5797
  },
  {
    "iso2": "ps",
    "slug": "palestine",
    "name": "Palestinian Territory",
    "lat": 31.9308,
    "lng": 35.2425
  },
  {
    "iso2": "pa",
    "slug": "panama",
    "name": "Panama",
    "lat": 8.4395,
    "lng": -80.1443
  },
  {
    "iso2": "pg",
    "slug": "papua-new-guinea",
    "name": "Papua New Guinea",
    "lat": -7.1569,
    "lng": 144.8349
  },
  {
    "iso2": "py",
    "slug": "paraguay",
    "name": "Paraguay",
    "lat": -23.4219,
    "lng": -58.3891
  },
  {
    "iso2": "pe",
    "slug": "peru",
    "name": "Peru",
    "lat": -8.5227,
    "lng": -74.1142
  },
  {
    "iso2": "ph",
    "slug": "philippines",
    "name": "Philippines",
    "lat": 15.5865,
    "lng": 121.8221
  },
  {
    "iso2": "pn",
    "slug": "pitcairn",
    "name": "Pitcairn",
    "lat": -24.3661,
    "lng": -128.315
  },
  {
    "iso2": "pl",
    "slug": "poland",
    "name": "Poland",
    "lat": 52.0685,
    "lng": 19.4357
  },
  {
    "iso2": "pt",
    "slug": "portugal",
    "name": "Portugal",
    "lat": 39.6753,
    "lng": -7.9337
  },
  {
    "iso2": "pr",
    "slug": "puerto-rico",
    "name": "Puerto Rico",
    "lat": 18.2162,
    "lng": -66.4943
  },
  {
    "iso2": "qa",
    "slug": "qatar",
    "name": "Qatar",
    "lat": 25.3185,
    "lng": 51.1979
  },
  {
    "iso2": "ro",
    "slug": "romania",
    "name": "Romania",
    "lat": 45.8245,
    "lng": 25.0942
  },
  {
    "iso2": "ru",
    "slug": "russia",
    "name": "Russian Federation",
    "lat": 59.0394,
    "lng": 98.6705
  },
  {
    "iso2": "rw",
    "slug": "rwanda",
    "name": "Rwanda",
    "lat": -2.0147,
    "lng": 29.9194
  },
  {
    "iso2": "re",
    "slug": "r-union",
    "name": "R\u00e9union",
    "lat": -21.1198,
    "lng": 55.5439
  },
  {
    "iso2": "bl",
    "slug": "saint-barthelemy",
    "name": "Saint Barthelemy",
    "lat": 17.9056,
    "lng": -62.8305
  },
  {
    "iso2": "sh",
    "slug": "saint-helena",
    "name": "Saint Helena",
    "lat": -15.963,
    "lng": -5.7174
  },
  {
    "iso2": "kn",
    "slug": "saint-kitts-and-nevis",
    "name": "Saint Kitts and Nevis",
    "lat": 17.3147,
    "lng": -62.7456
  },
  {
    "iso2": "lc",
    "slug": "saint-lucia",
    "name": "Saint Lucia",
    "lat": 13.8957,
    "lng": -60.969
  },
  {
    "iso2": "mf",
    "slug": "saint-martin",
    "name": "Saint Martin",
    "lat": 18.078,
    "lng": -63.0668
  },
  {
    "iso2": "pm",
    "slug": "saint-pierre-and-miquelon",
    "name": "Saint Pierre and Miquelon",
    "lat": 46.9515,
    "lng": -56.3247
  },
  {
    "iso2": "vc",
    "slug": "saint-vincent-and-the-grenadines",
    "name": "Saint Vincent and the Grenadines",
    "lat": 13.2548,
    "lng": -61.1938
  },
  {
    "iso2": "ws",
    "slug": "samoa",
    "name": "Samoa",
    "lat": -13.6343,
    "lng": -172.4411
  },
  {
    "iso2": "sm",
    "slug": "san-marino",
    "name": "San Marino",
    "lat": 43.9428,
    "lng": 12.4613
  },
  {
    "iso2": "st",
    "slug": "sao-tome-and-principe",
    "name": "Sao Tome and Principe",
    "lat": 0.2274,
    "lng": 6.6062
  },
  {
    "iso2": "sa",
    "slug": "saudi-arabia",
    "name": "Saudi Arabia",
    "lat": 24.136,
    "lng": 44.601
  },
  {
    "iso2": "gb-sct",
    "slug": "scotland",
    "name": "Scotland",
    "lat": 56.4907,
    "lng": -4.2026
  },
  {
    "iso2": "sn",
    "slug": "senegal",
    "name": "Senegal",
    "lat": 14.2289,
    "lng": -14.6109
  },
  {
    "iso2": "rs",
    "slug": "serbia",
    "name": "Serbia",
    "lat": 44.0268,
    "lng": 20.8568
  },
  {
    "iso2": "sc",
    "slug": "seychelles",
    "name": "Seychelles",
    "lat": -4.66,
    "lng": 55.4725
  },
  {
    "iso2": "sl",
    "slug": "sierra-leone",
    "name": "Sierra Leone",
    "lat": 8.5613,
    "lng": -11.7866
  },
  {
    "iso2": "sg",
    "slug": "singapore",
    "name": "Singapore",
    "lat": 1.3528,
    "lng": 103.8103
  },
  {
    "iso2": "sx",
    "slug": "sint-maarten",
    "name": "Sint Maarten",
    "lat": 18.0394,
    "lng": -63.0688
  },
  {
    "iso2": "sk",
    "slug": "slovakia",
    "name": "Slovakia",
    "lat": 48.6981,
    "lng": 19.581
  },
  {
    "iso2": "si",
    "slug": "slovenia",
    "name": "Slovenia",
    "lat": 46.1376,
    "lng": 14.8906
  },
  {
    "iso2": "sb",
    "slug": "solomon-islands",
    "name": "Solomon Islands",
    "lat": -9.6131,
    "lng": 160.1648
  },
  {
    "iso2": "so",
    "slug": "somalia",
    "name": "Somalia",
    "lat": 6.5245,
    "lng": 45.4004
  },
  {
    "iso2": "za",
    "slug": "south-africa",
    "name": "South Africa",
    "lat": -28.5536,
    "lng": 24.7525
  },
  {
    "iso2": "gs",
    "slug": "south-georgia-and-south-sandwich-islands",
    "name": "South Georgia and South Sandwich Islands",
    "lat": -54.3767,
    "lng": -36.7751
  },
  {
    "iso2": "kr",
    "slug": "south-korea",
    "name": "South Korea",
    "lat": 36.4024,
    "lng": 127.7622
  },
  {
    "iso2": "ss",
    "slug": "south-sudan",
    "name": "South Sudan",
    "lat": 7.6578,
    "lng": 30.3852
  },
  {
    "iso2": "es",
    "slug": "spain",
    "name": "Spain",
    "lat": 40.365,
    "lng": -3.6516
  },
  {
    "iso2": "lk",
    "slug": "sri-lanka",
    "name": "Sri Lanka",
    "lat": 7.6966,
    "lng": 80.6693
  },
  {
    "iso2": "sd",
    "slug": "sudan",
    "name": "Sudan",
    "lat": 15.6706,
    "lng": 29.9515
  },
  {
    "iso2": "sr",
    "slug": "suriname",
    "name": "Suriname",
    "lat": 4.0987,
    "lng": -55.8555
  },
  {
    "iso2": "sj",
    "slug": "svalbard",
    "name": "Svalbard",
    "lat": 78.5732,
    "lng": 16.0364
  },
  {
    "iso2": "se",
    "slug": "sweden",
    "name": "Sweden",
    "lat": 62.7342,
    "lng": 17.0624
  },
  {
    "iso2": "ch",
    "slug": "switzerland",
    "name": "Switzerland",
    "lat": 46.7368,
    "lng": 8.2869
  },
  {
    "iso2": "sy",
    "slug": "syria",
    "name": "Syria",
    "lat": 35.0975,
    "lng": 38.5117
  },
  {
    "iso2": "tj",
    "slug": "tajikistan",
    "name": "Tajikistan",
    "lat": 38.5693,
    "lng": 70.9422
  },
  {
    "iso2": "tz",
    "slug": "tanzania",
    "name": "Tanzania",
    "lat": -6.3558,
    "lng": 34.8183
  },
  {
    "iso2": "th",
    "slug": "thailand",
    "name": "Thailand",
    "lat": 13.6622,
    "lng": 101.0868
  },
  {
    "iso2": "tl",
    "slug": "east-timor",
    "name": "Timor-Leste",
    "lat": -8.8099,
    "lng": 125.9502
  },
  {
    "iso2": "tg",
    "slug": "togo",
    "name": "Togo",
    "lat": 8.6607,
    "lng": 0.8991
  },
  {
    "iso2": "tk",
    "slug": "tokelau",
    "name": "Tokelau",
    "lat": -9.1952,
    "lng": -171.8527
  },
  {
    "iso2": "to",
    "slug": "tonga",
    "name": "Tonga",
    "lat": -21.1593,
    "lng": -175.2042
  },
  {
    "iso2": "tt",
    "slug": "trinidad-and-tobago",
    "name": "Trinidad and Tobago",
    "lat": 10.4155,
    "lng": -61.3724
  },
  {
    "iso2": "tn",
    "slug": "tunisia",
    "name": "Tunisia",
    "lat": 34.0864,
    "lng": 9.6559
  },
  {
    "iso2": "tr",
    "slug": "turkey",
    "name": "Turkey",
    "lat": 38.9321,
    "lng": 35.5689
  },
  {
    "iso2": "tm",
    "slug": "turkmenistan",
    "name": "Turkmenistan",
    "lat": 39.0607,
    "lng": 58.4577
  },
  {
    "iso2": "tc",
    "slug": "turks-and-caicos-islands",
    "name": "Turks and Caicos Islands",
    "lat": 21.7999,
    "lng": -71.7406
  },
  {
    "iso2": "tv",
    "slug": "tuvalu",
    "name": "Tuvalu",
    "lat": -8.5147,
    "lng": 179.2178
  },
  {
    "iso2": "vi",
    "slug": "us-virgin-islands",
    "name": "US Virgin Islands",
    "lat": 17.738,
    "lng": -64.7616
  },
  {
    "iso2": "ug",
    "slug": "uganda",
    "name": "Uganda",
    "lat": 1.2822,
    "lng": 32.3437
  },
  {
    "iso2": "ua",
    "slug": "ukraine",
    "name": "Ukraine",
    "lat": 48.6575,
    "lng": 31.2738
  },
  {
    "iso2": "ae",
    "slug": "united-arab-emirates",
    "name": "United Arab Emirates",
    "lat": 24.1825,
    "lng": 54.2792
  },
  {
    "iso2": "gb",
    "slug": "united-kingdom",
    "name": "United Kingdom",
    "lat": 53.9784,
    "lng": -2.8529
  },
  {
    "iso2": "us",
    "slug": "united-states",
    "name": "United States",
    "lat": 38.8208,
    "lng": -96.3316
  },
  {
    "iso2": "um",
    "slug": "united-states-minor-outlying-islands",
    "name": "United States Minor Outlying Islands",
    "lat": 19.302,
    "lng": 166.638
  },
  {
    "iso2": "uy",
    "slug": "uruguay",
    "name": "Uruguay",
    "lat": -32.782,
    "lng": -56.0192
  },
  {
    "iso2": "uz",
    "slug": "uzbekistan",
    "name": "Uzbekistan",
    "lat": 41.4879,
    "lng": 63.8548
  },
  {
    "iso2": "vu",
    "slug": "vanuatu",
    "name": "Vanuatu",
    "lat": -15.1891,
    "lng": 166.8491
  },
  {
    "iso2": "va",
    "slug": "vatican",
    "name": "Vatican City",
    "lat": 41.904,
    "lng": 12.4513
  },
  {
    "iso2": "ve",
    "slug": "venezuela",
    "name": "Venezuela",
    "lat": 7.1483,
    "lng": -66.3649
  },
  {
    "iso2": "vn",
    "slug": "vietnam",
    "name": "Vietnam",
    "lat": 16.5173,
    "lng": 105.9134
  },
  {
    "iso2": "gb-wls",
    "slug": "wales",
    "name": "Wales",
    "lat": 52.1307,
    "lng": -3.7837
  },
  {
    "iso2": "wf",
    "slug": "wallis-and-futuna",
    "name": "Wallis and Futuna",
    "lat": -14.2834,
    "lng": -178.1274
  },
  {
    "iso2": "ye",
    "slug": "yemen",
    "name": "Yemen",
    "lat": 16.0014,
    "lng": 47.4682
  },
  {
    "iso2": "zm",
    "slug": "zambia",
    "name": "Zambia",
    "lat": -13.1628,
    "lng": 27.7552
  },
  {
    "iso2": "zw",
    "slug": "zimbabwe",
    "name": "Zimbabwe",
    "lat": -18.927,
    "lng": 29.7178
  }
];
